// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"8e0c846a","533":"312a2b25","596":"26ad7a93","730":"ab87a5a9","788":"23a252de"}[chunkId] + ".chunk.css";
};